<template>
  <div class="classPg">
    <!-- 搜索栏 -->
    <div @click="changeSearch()">
      <van-search
        v-model="search"
        @search="searchApi()"
        @clear="unableSearch()"
        placeholder="输入标题或内容"
      />
    </div>
    <!-- 点击搜索框后searchFlag: true -->
    <div class="searchContent" v-if="searchFlag">
      <Search
        :test.sync="searchTest"
        :htest="hTests.length ? hTests : searchTest"
        :flag="searchFlag"
        :resFlag="resFlag"
        @tag="setTag($event)"
      ></Search>
    </div>
    <div v-if="!searchFlag">
      <van-tabs @click="changeCatgorical" class="tabs1">
        <van-tab
          v-for="(item, index) in categoricals"
          :name="item.id"
          :title="item.name"
          :key="index"
          class="tabs2"
        >
          <span class="title"></span>
          <select v-model="sortType" class="sort" @change="changeCatgorical">
            <option v-for="(x, i) in options" :value="x.value" :key="i">
              {{ x.text }}
            </option>
          </select>
        </van-tab>
      </van-tabs>
      <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
        <van-list
          v-model="isUpLoading"
          :finished="upFinished"
          :immediate-check="false"
          :offset="10"
          finished-text="我是有底线的"
          @load="onLoadList"
        >
          <div v-for="item in tests" :key="item.id">
            <Card :item="item" @click="gotoDetail(item.id)"></Card>
          </div>
        </van-list>
      </van-pull-refresh>
      <div style="height: 2rem"></div>
      <Footer page="index"></Footer>
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Card from "@/components/Card";
import Search from "@/components/Search";
import { getAllCat, getTests } from "@/http/api";

export default {
  data() {
    return {
      search: "",
      searchFlag: false,
      resFlag: false,
      hTests: [],
      searchTest: [],
      type: "",
      categoricals: [
        {
          id: 0,
          name: "全部",
          number: 100,
        },
      ],
      sortType: "hot",
      options: [
        // {text: '按时间', value: 0},
        {
          text: "按热度",
          value: "hot",
        },
        {
          text: "按时间",
          value: "new",
        },
      ],
      tests: [],
      // 分页
      total: 0,
      pageSize: 100, // 每页条数
      pageIndex: 1, // 页码
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
    };
  },
  created() {
    // this.sortType = 'new';
    // 获取类别信息
    getAllCat().then((res) => {
      // console.log(res)
      this.categoricals = this.categoricals.concat(res.data.objects);
    });
    this.getroadList();
  },
  mounted() {},
  methods: {
    // 获取列表
    getroadList() {
      let params = {
        page: this.pageIndex,
        page_size: this.pageSize,
        label: this.sortType,
      };
      getTests(params)
        .then((res) => {
          console.log("获取列表", params, res);
          this.total = res.data.count;
          if (res.data.objects) {
            this.tests = this.tests.concat(res.data.objects);
            this.searchTest = this.tests;
          }
        })
        .finally(() => {
          this.isDownLoading = false;
          this.isUpLoading = false;
        });
    },
    // 切换显示UI
    changeSearch() {
      this.searchFlag = !this.searchFlag;
      this.resFlag = false;
      if (!this.searchFlag) {
        this.search = "";
        let testParam = {
          page: 1,
          page_size: this.pageSize,
          label: "hot",
        };
        getTests(testParam)
          .then((res) => {
            this.hTests = res.data.objects;
            console.log(this.hTests);
            this.searchTest = res.data.objects;
          })
          .catch((err) => {
            console.log("error in getHotTest", err);
          });
      }
    },
    // 展示搜索
    // showSearch() {
    //   this.searchFlag = true;
    // },
    // 搜索
    searchApi() {
      this.searchFlag = true;
      let testParam = {
        page: 1,
        page_size: this.pageSize,
        search: this.search,
      };
      getTests(testParam)
        .then((res) => {
          // console.log(res)
          this.resFlag = true;
          this.searchTest = res.data.count ? res.data.objects : [];
        })
        .catch((err) => {
          console.log("error in getHotTest", err);
        });
    },
    // 取消搜索
    unableSearch() {
      this.searchFlag = false;
      this.search = "";
      this.resFlag = false;
    },
    setTag(tag) {
      this.search = tag.name;
      // this.searchStr = tag.name;
      let testParam = {
        page: 1,
        tag: tag.id,
      };
      getTests(testParam)
        .then((res) => {
          // console.log(res)
          this.resFlag = true;
          this.searchTest = res.data.count ? res.data.objects : [];
        })
        .catch((err) => {
          console.log("error in getHotTest", err);
        });
    },
    // 改变查看类别
    changeCatgorical(name, title) {
      console.log(name, title);
      // 如果切换tab
      if (title) {
        // 如果是子类型
        if (name) {
          this.type = name;
          getTests({
            page: 1,
            page_size: this.pageSize,
            label: this.sortType,
            type: this.type,
          }).then((res) => {
            // console.log(res)
            this.tests = res.data.objects;
          });
        }
        // 如果是全部类型
        else {
          this.type = "";
          getTests({
            page: 1,
            page_size: this.pageSize,
            label: this.sortType,
          }).then((res) => {
            // console.log(res)
            this.tests = res.data.objects;
          });
        }
      }
      // 如果是切换排序规则
      else {
        if (this.type) {
          getTests({
            page: 1,
            page_size: this.pageSize,
            label: this.sortType,
            type: this.type,
          }).then((res) => {
            // console.log(res)
            this.tests = res.data.objects;
          });
        } else {
          getTests({
            page: 1,
            page_size: this.pageSize,
            label: this.sortType,
          }).then((res) => {
            // console.log(res)
            this.tests = res.data.objects;
          });
        }
      }
    },
    // TODO: 下拉刷新
    onDownRefresh() {
      this.tests = [];
      this.pageIndex = 1;
      this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
      this.getroadList(); // 加载数据
    },
    // 上拉加载请求方法
    onLoadList() {
      if (this.total > this.pageIndex * this.pageSize) {
        this.pageIndex++;
        this.getroadList();
      } else {
        this.upFinished = true;
      }
    },
  },
  components: {
    Footer,
    Card,
    Search,
  },
};
</script>

<style lang="less" scoped>
.title {
  width: 72px;
  height: 18px;
  font-size: 18px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #4a4a4a;
  line-height: 27px;
  margin-left: 16px;
}

.tabs2 {
  height: 25px;
  line-height: 25px;
  margin-bottom: 20px;
}

.sort {
  width: 20%;
  float: right;
  margin-right: 10px;
  height: 25px;
  border: none;
  color: #42686e;
  font-size: 15px;
}

.sort:focus {
  outline: 0 !important;
}

.tabs {
  margin-bottom: 30px;
}

.search {
  margin-top: 16px;
}

.van-search {
  padding-left: 16px;
  padding-right: 16px;
}

.card .detail .right {
  margin-right: 0 !important;
}

.van-tab {
  flex: 0 0 24%;
}

.classPg {
  .van-tab__text {
    font-size: 16px;
    color: #42686e;
  }

  .van-tab--active {
    .van-tab__text {
      font-size: 22px;
      color: #f7b270;
      font-weight: bold;
    }
  }

  .van-tabs__line {
    display: none;
  }

  .van-tabs__nav--line {
    width: 100%;
  }

  .van-icon-search {
    z-index: 1;
    width: 0.5rem;
    border-radius: 5px;
  }

  .van-field__control {
    background-color: #eceff5;
    border-radius: 5px;
    margin-left: -25px;
    padding-left: 29px;
    width: 345px;
  }

  .van-cell {
    line-height: 36px;
    padding: 0;
  }

  .van-field__left-icon {
    text-indent: 3px;
  }

  .van-pull-refresh {
    padding-left: 22px;
  }

  .van-search__content {
    padding-left: 0;
    background-color: #eceff5;
    border-radius: 8px;
  }

  .van-tab__text--ellipsis {
    overflow: inherit;
  }

  .van-tabs__wrap--scrollable .van-tab {
    flex-basis: 24% !important;
  }

  .van-tab {
    white-space: nowrap;
  }
}
</style>
